import { rgba } from 'polished';

import { Colours } from '@ratehub/base-ui';

import APPROVAL_LIKELIHOOD from '../definitions/ApprovalLikelihood';


export default {
    [APPROVAL_LIKELIHOOD.UNKNOWN]: {
        backgroundColour: Colours.STONE_LIGHTEST,
    },
    [APPROVAL_LIKELIHOOD.POOR]: {
        backgroundColour: Colours.WATERMELON_LIGHTEST,
    },
    [APPROVAL_LIKELIHOOD.FAIR]: {
        backgroundColour: rgba(Colours.TANGERINE_LIGHTEST, 0.5),
    },
    [APPROVAL_LIKELIHOOD.GOOD]: {
        backgroundColour: Colours.MINT_LIGHT,
    },
    [APPROVAL_LIKELIHOOD.VERY_GOOD]: {
        backgroundColour: Colours.MINT_DARK,
    },
    [APPROVAL_LIKELIHOOD.EXCELLENT]: {
        backgroundColour: Colours.GRAPE_LIGHTEST,
    },
    [APPROVAL_LIKELIHOOD.PREQUALIFIED]: {
        stroke: Colours.BLUEBERRY,
        backgroundColour: Colours.BLUEBERRY_LIGHTEST,
    },
};
